
/** 黑箱在这里定制化所有模块的vuex状态管理 */

const state = {
};

const getters = {
};

const actions = {
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

